import {Component, Vue} from 'vue-property-decorator'

import {menuBtn} from '@/utils/menu_level2_button'
import {delNullProperty} from "@/utils/index";

import {exportStudentData, getClassesCustomer, sendOutput, setCustomerListFinishByClassId} from "@/api/classManage";
import {File} from "@/views/customer/customer-transfrom/edit-customer-info/interface";
import moment from "moment/moment";


@Component({})
export default class ClassStudent extends Vue {
    tableHeadFilter = {
        grade: '',
        customerName: '',
        prevMarketCooperationName: '',
        dissertationType: '',
        backMoneyStatus: '',
    }
    loading = false
    tableData = []
    total = 0
    classId: number = undefined
    exportButtonDisabled = false

    timer = null
    createdAt = ''
    page = 1
    limit = 20
    gradeOptions = [
        '美制7年级/英制8年级/初一（普高）',
        '美制8年级/英制9年级/初二（普高）',
        '美制9年级/英制10年级/初三（普高）',
        '美制10年级/英制11年级/高一（普高）',
        '美制11年级/英制12年级/高二（普高）',
        '美制12年级/英制13年级/高三（普高）',
        '大学一年级',
        '大学二年级',
        '大学三年级',
        '大学四年级',
        '研究生及以上',
        '已毕业'
    ]
    dissertationTypeOptions = [
        '无',
        '国外独立一作',
        '国外共同一作',
        '国内独立一作',
        'CNKI英文独立一作'
    ]
    financeOrderIdList: any = []
    serviceDialog = false
    fileList = []
    previewPath = ''
    previewName = ''
    previewVisible = false
    isshowParentPhone = true
    isshowPhone = true
    isshowWeChat = true
    isshowEmail = true
    isshowPrevMarketCooperationName = true
    isshowEduCode = true
    serviceCompleteId = ''
    produceDialog = false
    checkedDataList = []

    buttonShow = menuBtn

    get baseUrl() {
        let str = '/fileApi/upload/upload'
        if (process.env.NODE_ENV !== "development") {
            if (window.location.origin.includes('-testserver')) {
                str = process.env.VUE_APP_DEV_FILE_API + 'upload/upload'
            } else {
                str = process.env.VUE_APP_MASTER_FILE_API + 'upload/upload'
            }
        }
        return str
    }

    created() {
        this.classId = Number(this.$route.query.id)  //跳转报名学员id
        this.getClassesCustomer()  //报名学员
    }


    fileExtension(type: any) {
        if (type) {
            return type.substring(type.lastIndexOf('.') + 1)
        }
    }


    getRowKeys(row: any) {
        return row.id
    }


    selectHandle(row) {
        if (row.finishAt) {
            return false
        }  //移除批量产出发送 复原批量服务完成逻辑
        return true // 满足条件一定记得返true, 不然全都会禁选
    }


    // 报名学员
    async getClassesCustomer() {
        this.loading = true
        const data: any = await getClassesCustomer(String(this.classId), delNullProperty({
            grade: this.tableHeadFilter.grade,
            customerName: this.tableHeadFilter.customerName,
            prevMarketCooperationName: this.tableHeadFilter.prevMarketCooperationName,
            dissertationType: this.tableHeadFilter.dissertationType,
            backMoneyStatus: this.tableHeadFilter.backMoneyStatus,
            limit: this.limit,
            page: this.page,
        }))
        this.tableData = data.classesCustomerList
        this.total = data.allNum
        this.$nextTick(() => {
            if (this.$refs.multipleTable) {
                (this.$refs.multipleTable as HTMLFormElement).doLayout();
                (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
            }
        });
        this.loading = false
    }

    // 导出
    async exportData() {
        this.exportButtonDisabled = true
        this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        exportStudentData(String(this.classId), delNullProperty({
            ...this.tableHeadFilter,
        })).then(() => {
            this.exportButtonDisabled = false
        }).catch(() => [
            this.exportButtonDisabled = false
        ])
    }

    handleSelectionChange(arr: any) {
        this.checkedDataList = arr
        console.log('this.checkedDataList', this.checkedDataList)
        // 选中的数据
        this.financeOrderIdList = []
        const newList = []
        arr.forEach(item => {
            newList.push(item.id)
        })
        this.financeOrderIdList = newList
    }

    AllService() {
        this.serviceDialog = true
    }

    // 服务完成
    handleServiceComplete(row) {
        // this.financeOrderIdList = [row.id]
        this.serviceCompleteId = row.id
        this.serviceDialog = true
        this.createdAt = null // 清空服务完成时间
    }

    returnSignContract(row) {
        //跳转新建学生合同
        window.open(window.location.origin + '/financialCenter/contractAddAgent?customerName=' + row.customerName
            + '&customerId=' + row.customerId + '&customerType=' + row.customerType +
            '&customerSourceType=' + row.customerSourceType +
            '&customerSource=' + '' + encodeURIComponent(row.customerSource) + '' +
            '&marketCooperationId=' + row.marketCooperationId + '&directorUserId=' + row.directorUserId
            + '&directorUserRealName=' + row.directorUserRealName,
            '_blank')
    }

    uploadSuccess(res) {
        const {data} = res
        this.$message.success('上传成功')
        this.fileList.push({name: data.name, url: data.ossUrl})
    }

    uploadError() {
        this.$message.error('上传失败')
    }

    handleUploadRemove(file) {
        this.fileList = this.fileList.filter(item => item.uid !== file.uid)
    }

    handleRemove(file, fileList) {
        this.fileList = fileList.map((item: File) => ({name: item.name, url: item.url}))
    }

    handlePreview(file) {
        this.previewPath = file.url
        this.previewName = file.name
        this.previewVisible = true
    }

    // 上传附件确定事件
    async clickServiceDialogConfirmButton() {
        if (!this.createdAt) {
            this.$message.error('请选择服务完成时间');
            return
        }
        this.serviceDialog = false
        const obj = {
            id:this.classId,
            financeOrderIdList: this.serviceCompleteId?[this.serviceCompleteId]: this.financeOrderIdList,
            url: this.fileList.length > 0 ? this.fileList[0].url : '',
            createdAt: moment(this.createdAt).format('YYYY-MM-DD')
        }
        const data = await setCustomerListFinishByClassId(delNullProperty(obj))
        this.getClassesCustomer()  //报名学员
        this.$message.success('服务完成')
        this.fileList = []
        this.financeOrderIdList = []
        this.serviceCompleteId = ''
        this.createdAt = null;
        (this.$refs.multipleTable as HTMLFormElement).clearSelection();
    }

    isshow(row) {
        if (row.parentPhone === undefined) {
            this.isshowParentPhone = false
        }
        if (row.phone === undefined) {
            this.isshowPhone = false
        }
        if (row.email === undefined) {
            this.isshowEmail = false
        }
        if (row.weChat === undefined) {
            this.isshowWeChat = false
        }
        if (row.prevMarketCooperationName === undefined) {
            this.isshowPrevMarketCooperationName = false
        }
        if (row.eduCode === undefined) {
            this.isshowEduCode = false
        }
        return true;
    }

    // 查看附件
    handleCheckAttachment(url) {
        window.open(url, '_blank')
    }


    // 跳转新建回款
    returnBackMoney(row) {
        window.open(window.location.origin + '/financialCenter/newBackMoneyStudent?orderId=' + row.id + '&isFrom=1', '_blank')
    }


    handleSizeChange(val: number) {
        this.limit = val
        this.getClassesCustomer()
    }

    handleCurrentChange(val: number) {
        this.page = val
        this.getClassesCustomer()
    }

    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getClassesCustomer()
        }, 1000)
    }

    /*跳转产出*/
    returnProduce(row) {
        const isFinish = row.finishAt ? true : false
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/AddClassStudentProduce?classId=' + this.classId + '&financeOrderId=' + row.id + '&isFinish=' + isFinish, "_blank")
        const time = setInterval(() => {
            if (win.closed) {
                this.getClassesCustomer()
                clearInterval(time)
            }
        }, 500)
    }

    AllProduce() {
        this.produceDialog = true
    }

    // 批量操作产出
    clickProduceDialogConfirmButton() {
        if (this.financeOrderIdList.length == 0) {
            this.$message.error('请选择要操作的学员')
            return
        }
        sendOutput(String(this.classId), {
            financeOrderIdList: this.financeOrderIdList,
        }).then(() => {
            this.$message.success('操作成功')
            this.produceDialog = false
        })
    }

    openProduceRecord(row) {
        const isFinish = row.finishAt ? true : false
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/ClassStudentProduceRecord?classesId='  + this.classId + '&financeOrderId=' + row.id + '&isFinish=' + isFinish, "_blank")
        const time = setInterval(() => {
            if (win.closed) {
                clearInterval(time)
            }
        }, 500)
    }
}
